import { atom, selector } from 'recoil'

export const pageState = atom({
  key: 'SourceViewContentPageState',
  default: {
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    isEmptyState: false,
    sourceName: '',
    searching: false,
    expandedAdvacedSerach: false
  }
})

export const resultsState = atom({
  key: 'SourceViewContentResultsState',
  default: {
    items: [],
    totalItems: 0
  }
})

export const searchState = atom({
  key: 'SourceViewContentSearchState',
  default: {
    pageNumber: 1,
    pageSize: 10,
    orderBy: 'ContentDate',
    orderDescending: true,
    searchBy: 'Title',
    searchDateBy: 'ContentDate',
    searchText: '',
    searchDateFrom: undefined,
    searchDateTo: undefined
  }
})

export const resultsStateEmptyState = selector({
  key: 'SourceViewContentStateEmptyState',
  get: ({ get }) => {
    const { totalItems } = get(resultsState)
    const { searching } = get(pageState)

    return !totalItems && !searching
  }
})
